import React from 'react'

export default function MyResume() {
  return (
    <div className='myresume' id="myresume">
         <h1 className="title">MY RESUME</h1>
        <div className="container">
                    <div className="one">
                        <div className="year">2020-Present</div>
                        <h3>SOFTWARE ENGINEERING STUDENT</h3>
                        <p>At the National School of Applied Sciences of Oujda</p>
                    </div>
                    <div className="two">
                        <div className="year">2018-2020</div>
                        <h3>INTEGRATED PREPARATORY CLASSES</h3>
                        <p>At the National School of Applied Sciences of Oujda</p>
                    </div>
                    <div className="three">
                        <div className="year">2017-2018</div>
                        <h3>MATHEMATICAL SCIENCES BACCALAUREATE</h3>
                        <p>ABDELKARIM ELKHATTABI High School of Nador</p>
                    </div>
        </div>
    </div>
  )
}
